import React, { useState } from 'react';
import { List } from "@phosphor-icons/react";
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="relative bg-pearl">
      <div className="absolute w-full z-[-1]">
        <div className="h-8 bg-pearl-medium"></div>
        <div className="h-2.5 bg-pearl-dark"></div>
        <div className="h-[171px] bg-pearl"></div>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-sky-800 font-bungee">

        <div className="hidden md:block text-right text-sm py-2">
          <a className="px-6 border-l border-white" href="https://www.sos.state.tx.us/about/sosbio.shtml" title="Leaving site for the Secretary's biography on sos.state.tx.us">Secretary Jane Nelson</a>
          <a className="px-6 border-l border-white" href="https://www.votetexas.gov/" title="Leaving site for VoteTexas.gov">VoteTexas.gov</a>
          <a className="px-6 border-l border-white" href="https://www.votetexas.gov/get-involved/student-clerks.html" title="Leaving site for sos.state.tx.us">Student Workers</a>
        </div>

        <nav className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <Link to="/index.html" onClick={closeMenu}>
              <span className="text-4xl">PROJECT V.O.T.E.</span>
            </Link>
          </div>

          <div className="hidden md:flex space-x-8">
            {/* Navigation links */}
            <Link to="teachers" onClick={closeMenu}>
              <div className="flex flex-col items-center">
                <img src={`${process.env.PUBLIC_URL}/images/teachers-icon.png`} alt="Teachers Nav" className="w-[62.5px] h-[50px]" />
                <span className="text-xs mt-1">Teachers</span>
              </div>
            </Link>
            <Link to="students" onClick={closeMenu}>
              <div className="flex flex-col items-center">
                <img src={`${process.env.PUBLIC_URL}/images/students-icon.png`} alt="Students Nav" className="w-[62.5px] h-[50px]" />
                <span className="text-xs mt-1">Students</span>
              </div>
            </Link>
            <Link to="resources" onClick={closeMenu}>
              <div className="flex flex-col items-center">
                <img src={`${process.env.PUBLIC_URL}/images/about-icon.png`} alt="Home Nav" className="w-[62.5px] h-[50px]" />
                <span className="text-xs mt-1">Resources</span>
              </div>
            </Link>
            <a href="mailto:info" onClick={closeMenu}>
              <div className="flex flex-col items-center">
                <img src={`${process.env.PUBLIC_URL}/images/contact-icon.png`} alt="Contact Us" className="w-[62.5px] h-[50px]" />
                <span className="text-xs mt-1">Contact</span>
              </div>
            </a>
          </div>

          <button
            className="md:hidden z-50 p-2 border-0 bg-transparent"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <div className="w-12 flex flex-col justify-between h-5">
              <List size={32} />
            </div>
          </button>
        </nav>

        {/* Mobile menu */}
        <div
          className={`md:hidden bg-pearl fixed inset-x-0 top-0 z-40 transform ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'
            } transition-transform duration-300 ease-in-out`}
        >
          <div className="flex flex-col items-center justify-center min-h-screen space-y-8 pt-16">
            <Link title="Home nav" to="/index.html" className="text-2xl text-navy-600" onClick={closeMenu}>Home</Link>
            <Link title="Teachers nav" to="/teachers" className="text-2xl text-navy-600" onClick={closeMenu}>Teachers</Link>
            <Link title="Students nav" to="/students" className="text-2xl text-navy-600" onClick={closeMenu}>Students</Link>
            <Link title="About nav" to="/resources" className="text-2xl text-navy-600" onClick={closeMenu}>Resources</Link>
            <a title="Contact nav" href="mailto:info" className="text-2xl text-navy-600" onClick={closeMenu}>Contact</a>

            <div className="text-sm mt-8">
              <a className="block py-2" href="https://www.sos.state.tx.us/about/sosbio.shtml" title="Leaving site for the Secretary's biography on sos.state.tx.us">Secretary Jane Nelson</a>
              <a className="block py-2" href="https://www.votetexas.gov/" title="Leaving site for VoteTexas.gov">VoteTexas.gov</a>
              <a className="block py-2" href="https://www.votetexas.gov/get-involved/student-clerks.html" title="Leaving site for sos.state.tx.us">Student Workers</a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
